var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "px-ogs bg-paint pb-40" }, [
    _c("div", { staticClass: "max-w-6xl mx-auto" }, [
      _c(
        "div",
        { staticClass: "grid grid-cols-12 gap-x-gs gap-y-8" },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "col-span-4" },
            [_c("FlexibleContentRichPartnersItem", { attrs: { item: item } })],
            1
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }